import { Icon, LiveRegion } from '@global-ecom/nitro-uds/elements';

import { usePdp } from 'hooks/usePdp';

export const AddToCartErrorMessage = () => {
  const { addToCartError, errorAnnouncementTrigger } = usePdp();

  return (
    <div hidden={!addToCartError} data-test-id="pdp-add-to-cart-error">
      {addToCartError && (
        <LiveRegion
          type="assertive"
          role="alert"
          key={errorAnnouncementTrigger}
        >
          <p className="flex items-center space-x-3 justify-between text-puma-red border border-puma-red font-bold px-3 py-2 text-sm rounded">
            <span>{addToCartError}</span>
            <Icon name="exclamation-outline" size="2xl" />
          </p>
        </LiveRegion>
      )}
    </div>
  );
};
